
<template>
  <div :style="{ backgroundColor: info.bg_color || '#3f3f3f' }" class="home">
    <nav
      style="background: inherit"
      class="navbar"
      role="navigation"
      aria-label="main navigation"
    >
      <h1 class="page-header">{{ info.name }}</h1>
      <div class="navbar-end">
        <div class="navbar-item">
          <button class="button is-small is-warning">
            {{
              currentGame.status == "winner_declared"
                ? "GAME OVER"
                : "GAME IS " + currentGame.status.toUpperCase()
            }}
          </button>
        </div>
      </div>
    </nav>
    <div
      :style="{ backgroundColor: info.p_color || '#000071' }"
      style="
        font-size: 12px;
        margin-left: 5px;
        margin-top: 5px;
        margin-right: 5px;
        padding: 5px;
        border-radius: 12px;
        font-weight: bold;
      "
    >
      <div
        v-for="row in 10"
        :key="row"
        style="margin-bottom: 1px"
        class="columns is-centered is-gapless is-mobile"
      >
        <div
          v-for="column in 9"
          :key="row + '-' + column"
          style="margin: 2px; border-radius: 5px"
          class="column has-background-light"
          :class="{
            'has-background-success has-text-white': polledNumbers.includes(
              column * 10 + row - 10
            ),
          }"
        >
          {{ column * 10 + row - 10 }}
        </div>
      </div>
    </div>

    <div
      class="has-background-dark has-text-white"
      style="
        margin: 5px;
        font-size: 12px;
        padding: 5px;
        border-radius: 8px;
        font-weight: bold;
      "
    >
      <p style="text-align: left">Numbers:</p>
      {{ polledNumbers.join(",&nbsp;") }}
    </div>

    <div
      v-for="card in myTickets"
      :key="card.number"
      :style="{ backgroundColor: info.p_color || '#000071' }"
      class="card"
      style="margin: 5px; border-radius: 8px; padding: 10px"
    >
      <p style="padding: 0px" class="card-header-title has-text-white">
        LOTTO TICKET: {{ card.number }} {{ card.name }}
        <span style="margin: 0 0 0 auto" @click="removeFromTicket(card)">
          <b-icon icon="close"></b-icon>
        </span>
      </p>
      <div class="" style="font-size: 12px; padding: 0px">
        <div
          v-for="row in 3"
          :key="row"
          style="margin-bottom: 0px"
          class="columns is-centered is-gapless is-mobile"
        >
          <div
            v-for="column in 9"
            :key="row + '-' + column"
            class="column has-background-white"
            style="padding: 0.1rem !important; margin: 2px; border-radius: 5%"
            :class="{
              'has-background-success': polledNumbers.includes(
                card.card[row + 3 * column - 4]
              ),
            }"
          >
            {{ card.card[row + 3 * column - 4] }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px; margin-bottom: 50px">
      <button
        @click="pickTicket"
        class="button has-background-dark has-text-white"
        style="
          margin: 5px;
          font-size: 17px;
          border: 2px solid white;
          padding: 10px;
          border-radius: 8px;
          font-weight: bold;
        "
      >
        Pick Ticket
      </button>
    </div>
    <section style="text-align: left">
      <h3
        class="is-size-4 has-text-white"
        style="text-align: center; font-size: 20px"
      >
        Winners
      </h3>
      <div style="padding: 10px">
        <div class="columns is-multiline is-mobile">
          <div
            v-for="game in winnerType"
            :key="game.key"
            class="column is-full"
          >
            <section>
              <div class="has-background-white">
                <div
                  :style="{ backgroundColor: info.p_color || '#000071' }"
                  :class="{
                    'card-header': true,
                    'has-background-danger': !!game.users.length,
                  }"
                  role="button"
                >
                  <p class="card-header-title has-text-white">
                    {{ game.name }}
                  </p>
                </div>
                <div class="card-content">
                  <div
                    style="text-align: left; font-size: 10px"
                    class="content"
                  >
                    <ul>
                      <h4
                        style="
                          cursor: pointer;
                          padding: 10px;
                          background: yellow;
                          border: 2px solid black;
                          border-radius: 10px;
                        "
                        @click="openTicket(winner)"
                        v-for="(winner, index) in game.users"
                        :key="winner.ticket"
                      >
                        <span>{{ index + 1 }} T.No. {{ winner.ticket }}</span>
                        (By {{ winner.name.toUpperCase() }})
                      </h4>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="columns is-mobile"></div>
      </div>
    </section>
    <b-modal
      :active.sync="winnerTicketModel"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-subtitle">
            LOTTO TICKET:
            {{ parseInt(activeWinner.ticket).toString().padStart(3, "0") }} ,
            WINNER:
            {{ activeWinner.name ? activeWinner.name.toUpperCase() : "" }}
          </p>
        </header>
        <section class="modal-card-body">
          <div
            :key="card.ticket"
            v-for="card in cards.filter(
              (card) =>
                card.number ==
                parseInt(activeWinner.ticket).toString().padStart(3, '0')
            )"
            class="has-background-primary"
            style="font-size: 20px; padding-bottom: 5px; padding-top: 5px"
          >
            <div
              v-for="row in 3"
              :key="row"
              style="margin-bottom: 0px"
              class="columns is-centered is-gapless is-mobile"
            >
              <div
                v-for="column in 9"
                :key="row + '-' + column"
                class="column has-background-white"
                style="
                  padding: 0.2rem !important;
                  margin: 2px;
                  border-radius: 5%;
                  width: 45px;
                  max-width: 45px;
                  height: 35px;
                "
                :class="{
                  'has-background-light': (row + 3 * column - 4) % 2,
                  'has-background-success has-text-white':
                    polledNumbers.slice(0,polledNumbers.indexOf(activeWinner.at)+1).includes(card.card[row + 3 * column - 4]),
                }"
              >
                {{ card.card[row + 3 * column - 4] }}
              </div>
            </div>
          </div>
          <div>Won at {{ activeWinner.at }}</div>
        </section>
      </div>
    </b-modal>

    <notifications group="live" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
export default {
  data() {
    return {
      myTickets: [],
      polledNumbers: [],
      winnerType: [],
      sheets: [],
      notifier: [],
      winninNum: {
        early_five: 91,
        star: 92,
        top_line: 93,
        middle_line: 94,
        bottom_line: 95,
        box_bonus: 96,
        half_sheet: 97,
        fullhouse: 98,
        fullhouse_2: 99,
        fullhouse_3: 100,
        full_sheet: 101,
        corners: 102,
      },
      priorityMap: {
        fullhouse: 1,
        fullhouse_2: 2,
        fullhouse_3: 3,
        half_sheet: 4,
        top_line: 5,
        middle_line: 6,
        bottom_line: 7,
        star: 8,
        early_five: 9,
        corners: 10,
        early_seven: 11,
        box_bonus: 12,
      },
      winnerTicketModel: false,
      activeWinner: {},
    };
  },
  computed: {
    ...mapState(["cards", "info", "currentGame"]),
  },
  methods: {
    pickTicket() {
      this.$buefy.dialog.prompt({
        message: `What's your ticket number?`,
        inputAttrs: {
          type: "number",
          maxlength: 3,
          min: 1,
        },
        trapFocus: true,
        onConfirm: (value) => {
          let already = this.myTickets.some(
            (card) => card.number == parseInt(value).toString().padStart(3, "0")
          );
          if (already) return;
          if (!this.cards[parseInt(value) - 1]) return;
          const sheet = this.sheets.find((sheet) =>
            sheet.includes(parseInt(value))
          );
          if (sheet) {
            return sheet.forEach((ticket) =>
              this.myTickets.push(this.cards[parseInt(ticket) - 1])
            );
          }
          this.myTickets.push(this.cards[parseInt(value) - 1]);
        },
      });
    },
    removeFromTicket(delticket) {
      this.myTickets = this.myTickets.filter(
        (ticket) => ticket.number !== delticket.number
      );
    },
    say(m) {
      var msg = new SpeechSynthesisUtterance();
      msg.text = m;
      msg.lang = "en-US";
      speechSynthesis.speak(msg);
    },
    listenEvents() {
      firebase
        .database()
        .ref("games")
        .child(this.currentGame.uid)
        .child("data")
        .child("polled")
        .on("child_added", (snap) => {
          this.polledNumbers.push(snap.val());
          if (this.currentGame.status !== "winner_declared") {
            this.notifier.push(snap.val());
          }
        });

      firebase
        .firestore()
        .collection("games")
        .doc(this.currentGame.uid)
        .onSnapshot((doc) => {
          if (
            doc.data().status == "winner_declared" &&
            this.currentGame.status !== "winner_declared"
          ) {
            this.$buefy.dialog.alert({
              title: "Game Over!",
              ariaRole: "alertdialog",
              ariaModal: true,
            });
            this.$store.commit("SET_GAME_STATUS", "winner_declared");
          }
        });
      setInterval(() => {
        if (this.notifier.length) {
          let item = this.notifier.pop();
          try {
            const audioObj = new Audio(
              require("@/assets/sound/" + item + ".mp3")
            );
            audioObj.play();
          } catch (error) {
            console.error(error);
          }
          //this.notify("Number "+item);
          this.notifier = [];
        }
      }, 1000);
    },
    openTicket(winner) {
      this.activeWinner = winner;
      this.winnerTicketModel = true;
    },
    notify(title) {
      this.$buefy.snackbar.open({
        message: title,
        type: "is-warning",
        queue: false,
        position: "is-top",
        actionText: null,
      });
    },
  },
  mounted() {
    if (this.info.logo_color) {
      document.querySelectorAll(".page-header").forEach((el) => {
        el.style.color = this.info.logo_color;
      });
    }
  },
  created() {
    this.listenEvents();
    firebase
      .database()
      .ref("games")
      .child(this.currentGame.uid)
      .child("data")
      .once("value", (snap) => {
        if (snap.child("sheetUsers").val()) {
          this.sheets = snap.child("sheetUsers").val();
        }
        Object.keys(snap.child("gameType").val()).forEach((val) => {
          if (val == "fullhouse") {
            return this.winnerType.push({
              name: "FIRST FULLHOUSE",
              key: val,
              users: [],
            });
          }
          if (val == "fullhouse_2") {
            return this.winnerType.push({
              name: "SECOND FULLHOUSE",
              key: val,
              users: [],
            });
          }
          if (val == "fullhouse_3") {
            return this.winnerType.push({
              name: "THIRD FULLHOUSE",
              key: val,
              users: [],
            });
          }
          this.winnerType.push({
            name: val.replace("_", " ").toUpperCase(),
            key: val,
            users: [],
          });
        });

        this.winnerType.sort((a, b) => {
          return this.priorityMap[a.key] - this.priorityMap[b.key];
        });

        firebase
          .database()
          .ref("games")
          .child(this.currentGame.uid)
          .child("winners")
          .on("child_added", (snap) => {
            let wintype = this.winnerType.find((game) => game.key == snap.key);
            if (wintype) {
              snap.forEach((val) => {
                wintype.users.push(val.val());
                if (this.currentGame.status !== "winner_declared") {
                  this.notifier.push(this.winninNum[snap.key]);
                }
              });
              return;
            }
          });
      });
  },
};
</script>

